module.exports = __webpack_public_path__ + "img/small_t2_cors_nut.prt.c9b0e73a.jpg";